/** Port von `IwmDialogRechnungDokumenteList.razor` (`@inherits IwmDialogDokumentList`). */

import { useCallback } from 'react';

import { receiptApi } from '@/api/services/receiptApi';

import { DocumentListDialog } from './DocumentListDialog';
import { useReceiptMatchcode } from './matchcode';

export interface ReceiptDocumentListDialogProps {
  open: boolean;
  onClose: () => void;
  viewId: number;
  receiptId: number;
}

export function ReceiptDocumentListDialog(props: ReceiptDocumentListDialogProps) {
  const { receiptId, viewId } = props;
  const matchcode = useReceiptMatchcode(props.open, viewId, receiptId);

  // Port von `Fetch()`.
  const fetchDocuments = useCallback(
    () => receiptApi.getDocuments(viewId, receiptId),
    [receiptId, viewId],
  );

  return (
    <DocumentListDialog
      open={props.open}
      onClose={props.onClose}
      matchcode={matchcode}
      fetchDocuments={fetchDocuments}
    />
  );
}

export default ReceiptDocumentListDialog;
